import React from 'react'
import { Box, Grid } from '@mui/material';
import Features from '../../Components/NewsSessionComponents/Features';
import LatestSession from '../../Components/NewsSessionComponents/LatestSession';

function NewsSection({ groupedCategory, ads, filteredNews }) {
    const style = {
        marginBottom: "20px",
        padding: "6px",
        borderRadius: "10px",
        background: "rgba(255, 255, 255, 0.5)",
        backdropFilter: "blur(12px) saturate(160%)",
        WebkitBackdropFilter: "blur(12px) saturate(160%)",
        border: "1px solid rgba(255, 255, 255, 0.5)",
        boxShadow: "0 2px 8px rgba(28, 35, 101, 0.06)",
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={9}>
                <Features groupedCategory={groupedCategory} />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={3}>
                <LatestSession filteredNews={filteredNews} />
                {ads.map((ads, index) => (
                    <Box style={style} key={index}>
                        <img alt="complex" src={ads?.image?.url} style={{ width: '100%', height: '100%', borderRadius: 5 }} />
                    </Box>
                ))}
            </Grid>
        </Grid>
    )
}

export default NewsSection;